import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import dynamic from 'next/dynamic';
import TinaAsset from 'components/TinaAsset';
import { blockPadV, blockPadH, blockW } from 'theme/mixins/padding';
import type { VideoBlock as T } from './types';
import TinaVideo from 'components/TinaVideo';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

interface AssetWrapper {
  hasMobileImage?: boolean;
  hasMobileLottie?: boolean;
}

interface Container {
  backgroundVideoColor: string;
  topbotPadding: number;
  sidePadding: number;
}

const Wrapper = styled.div`
  ${blockPadV()};
  margin: 0 3px;

  ${({ theme }) => theme.mq.md`
    margin: auto;
    ${blockPadH()};
  `};

  background: ${({ theme }) => theme.themeColors.bg};
`;

const Container = styled.div<Container>`
  ${blockW()};
  border-radius: 1rem;
  ${({ theme, backgroundVideoColor, topbotPadding, sidePadding }) =>
    (topbotPadding || sidePadding) &&
    theme.mq.md`
      background: ${backgroundVideoColor || 'transparent'};
      padding: ${topbotPadding}rem ${sidePadding}rem;
      border-radius: 1.5rem;
    `}
`;

const VideoWrapper = styled.div<AssetWrapper>`
  display: ${({ hasMobileImage, hasMobileLottie }) =>
    hasMobileImage || hasMobileLottie ? 'none' : 'initial'};

  ${({ theme }) =>
    theme.mq.md`
    display: initial;
  `}
`;

const ImageWrapper = styled.div<AssetWrapper>`
  display: ${({ hasMobileImage }) => (hasMobileImage ? 'initial' : 'none')};

  ${({ theme }) =>
    theme.mq.md`
    display: none;
  `}
`;

const LottieWrapper = styled.div<AssetWrapper>`
  display: ${({ hasMobileLottie }) => (hasMobileLottie ? 'initial' : 'none')};
  svg {
    border-radius: 16px;
  }
  ${({ theme }) =>
    theme.mq.md`
    display: none;
  `}
`;

const VideoBlock: React.FC<T> = ({
  backgroundVideoColor,
  videoMeta,
  hasMobieImage,
  mobileImage,
  topbotPadding,
  sidePadding,
  hasMobileLottie,
  lottieFp
}) => {
  const [lottie, setLottie] = useState();

  const fetchLottie = async () => {
    if (lottieFp) {
      const res = await axios.get(lottieFp);
      if (res?.status === 200) setLottie(res?.data);
    }
  };

  useEffect(() => {
    fetchLottie();
  }, []);
  return (
    <Wrapper>
      <Container
        topbotPadding={topbotPadding || 0}
        sidePadding={sidePadding || 0}
        backgroundVideoColor={backgroundVideoColor || ''}
      >
        <LottieWrapper hasMobileLottie={!!hasMobileLottie}>
          <Lottie animationData={lottie} loop={true} />
        </LottieWrapper>
        <ImageWrapper hasMobileImage={!!hasMobieImage}>
          <TinaAsset asset={mobileImage} />
        </ImageWrapper>
        <VideoWrapper hasMobileImage={!!hasMobieImage} hasMobileLottie={!!hasMobileLottie}>
          <TinaVideo src={videoMeta?.url} {...videoMeta} />
        </VideoWrapper>
      </Container>
    </Wrapper>
  );
};

export default VideoBlock;
